<template>
  <card-wrapper v-if="coupon"
    :max-width="history ? 'auto' : 'min(90vw, 400px)'"
    :isHeightDisabled="true"
    class="coupon-options-detail-card"
    :class="{ 'history-coupon': history }"
    :on-click="openConfig"
    :is-active="isActive(coupon) && !immutable"
    :clear-active="clearCoupon"
    override-text-body-padding-left="22px"
  >
    <template v-slot:textBody>
      <div @click.stop="">
        <v-row class="header-row align-center no-gutters">
          <v-col cols="12" class="d-flex align-center justify-space-between">
            <div class="detail-header" :class="{'error-title': isDisabled, 'history-title': history}">
              <strong>{{ couponName }}</strong>
            </div>
          </v-col>
        </v-row>
        <v-row class="description-row no-gutters">
          <v-col cols="12">
            <!-- <div class="coupon-description">
              {{ coupon.description }}
            </div> -->
            <ul class="coupon-rules-list" :class="{ 'history-rules': history }" v-if="hasRules && hasRules.length">
              <template v-if="hideDetails">
                <li v-for="(rule, idx) in hasRules" :key="idx" class="description-expanded">
                  {{ rule }}
                </li>
              </template>
              <template v-else-if="!showAllDetails">
                <li class="description-collapsed">
                  {{ hasRules[0] }}
                </li>
                <li v-if="hasRules.length > 1" class="description-collapsed-ellipsis">
                  {{ hasRules[1] }}
                  <span v-if="hasRules.length > 2">…</span>
                </li>
              </template>
              <template v-else>
                <li v-for="(rule, idx) in hasRules" :key="idx" class="description-expanded">
                  {{ rule }}
                </li>
              </template>
            </ul>
            <div v-else style="display: flex; flex-direction: column; align-items: flex-start;">
              <span class="offer-expiry">• {{ $vuetify.t('$vuetify.account.rewards.noLimitation') }}</span>
            </div>
            <div class="more-detail-link" v-if="!history" @click.stop="openConfig">
              More Details
            </div>
          </v-col>
        </v-row>
      </div>
    </template>

    <template v-slot:description>
      <div v-if="showItems && coupon.orderItem && coupon.orderItem.childItemList && coupon.orderItem.childItemList.length > 0" class="redeemed-items-section mt-1">
        <div v-for="(relation, relationIdx) in coupon.orderItem.childItemList || []" :key="relationIdx" class="redeemed-item-entry">
          <div v-for="(item, itemIdx) in consolidateItems(relation.childItemList)" :key="`${relationIdx}-${itemIdx}`" class="individual-redeemed-item">
            <v-row style="display:flex; justify-content: space-between" class="align-center no-gutters">
              <v-col cols="8">
                <span class="item-name">
                  <strong>{{ item.qty || 1 }} {{ findDisplayText(item) }}</strong>
                </span>
              </v-col>
              <v-col cols="4" class="text-right">
                <span v-if="'itemPrice' in item && 'unitDiscount' in item && item.unitDiscount < 0" class="mr-2 caption text-decoration-line-through red--text">
                  {{ (item.itemPrice - item.unitDiscount) | currency}}
                </span>
                <template v-if="'itemPrice' in item">
                  <span class="item-price">{{ item.itemPrice | currency }}</span>
                </template>
                <common-price v-else class="item-price mr-2" :init-charges="item.charges || []" />
              </v-col>
            </v-row>

            <div v-for="(config, configIdx) in fetchConfigItems(item)" :key="`${relationIdx}-${itemIdx}-config-${configIdx}`" class="item-attribute-line">
              <span class="item-attribute-qty" v-if="config.qty && config.qty !== 1">{{ config.qty }}</span>
              <span class="item-attribute-name">{{ config.name }}</span>
              <span class="item-attribute-price-value" v-if="config.price">{{ config.price | currency }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="isPurchasable" class="mt-2">
        <v-row class="no-gutters">
          <v-col cols="12">
            Add to account for:
            <common-price class="mr-2" :init-charges="coupon.charges.map(charge => {return {...charge, price: charge.value}})" />
          </v-col>
        </v-row>
      </div>
      <v-row v-if="isDisabled && !isPurchasable" class="no-gutters mt-2">
        <v-col cols="12" class="text-center red--text caption">
          {{ $vuetify.t('$vuetify.account.rewards.inEligible') }}
        </v-col>
      </v-row>
      <div class="offer-expiry" v-if="!history && getExpirationDescription">
        • {{getExpirationDescription}}
      </div>
      <div v-else-if="!history" class="offer-expiry">
        {{ $vuetify.t('$vuetify.account.rewards.noExpiration') }}
      </div>
    </template>
  </card-wrapper>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { matchTranslation } from "@/services/util.service"
import { formatDiscountCap } from "@/services/currency.service"
import get from 'lodash/get';


import CommonPrice from "@/components/Common/CommonPrice"
import CardWrapper from "@/components/Wrappers/CardWrapper"
import HeaderBarApps from '@/components/ExternalAppsLinks'

export default {
  components: { CardWrapper, CommonPrice },
  extends: HeaderBarApps,

  props: {
    coupon: {
      type: Object,
      default: null
    },

    allowConfig: {
      type: Boolean,
      default: false
    },

    showItems: {
      type: Boolean,
      default: false
    },

    immutable: {
      type: Boolean,
      default: false
    },

    hideDetails: {
      type: Boolean,
      default: false
    },

    history: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      showAllDetails: false,
    }
  },
  computed: {
    isDisabled() {
      return !get(this.coupon, 'eligibilityResult.isEligible', true) && !this.isPurchasable
    },
    isPurchasable() {
      return !!this.coupon.charges && !this.coupon.uuid
    },

    // The cart passes the coupon from the /shoppingcart response, whose name comes from the
    // coupon definition and can be empty even when the coupon list (carousel) has one --
    // fall back the same way hasRules/getExpirationDescription do: first to the coupon the
    // guest picked (saved across reloads), then to the customer's coupon list.
    couponName() {
      if (this.coupon.name) return this.coupon.name
      const code = this.coupon.code
      const match = [...(this.getActiveCoupon || []), ...get(this.getCustomerRewards, 'coupons', [])]
        .find(c => c && c.code === code && c.name)
      return match ? match.name : ''
    },

    hasRules() {
      let rules = get(this.coupon, 'eligibilityResult.ruleDetailDescriptions', get(this.coupon, 'ruleResult.ruleDetailDescriptions', []))
      
      if (!rules || rules.length === 0) {
        const globalCoupons = get(this.getCustomerRewards, 'coupons', [])
        const matchingCoupon = globalCoupons.find(c => c.code === (this.coupon && this.coupon.code))
        if (matchingCoupon) {
          rules = get(matchingCoupon, 'eligibilityResult.ruleDetailDescriptions', get(matchingCoupon, 'ruleResult.ruleDetailDescriptions', []))
        }
      }

      // DEV-10491: a capped percentage coupon lists its cap first, same as CouponCard.
      const cap = formatDiscountCap(get(this.coupon, 'maxDiscountAmount'), this.getCurrencyCode)
      return cap ? [this.$vuetify.t('$vuetify.account.rewards.maxDiscountOf', cap), ...(rules || [])] : rules
    },

    getExpirationDescription() {
      let expiration = get(this.coupon, 'eligibilityResult.expirationDescription') || get(this.coupon, 'ruleResult.expirationDescription')
      
      if (!expiration) {
        const globalCoupons = get(this.getCustomerRewards, 'coupons', [])
        const matchingCoupon = globalCoupons.find(c => c.code === (this.coupon && this.coupon.code))
        if (matchingCoupon) {
          expiration = get(matchingCoupon, 'eligibilityResult.expirationDescription') || get(matchingCoupon, 'ruleResult.expirationDescription')
        }
      }
      
      return expiration
    },
    ...mapGetters([ 'getStore', 'getExistingOrder', 'getActiveCoupon', 'isLoggedIn', 'getFinalChargeFromCharges', 'getCustomerRewards', 'getCurrencyCode' ])
  },
  methods: {
    getImage(coupon) {
      if (coupon.imageUrl)
        return `${process.env.VUE_APP_API_IMAGE}${coupon.imageUrl}`

      if (this.getStore.images && 'REWARD' in this.getStore.images && this.getStore.images.REWARD[0] && this.getStore.images.REWARD[0].url)
        return `${process.env.VUE_APP_API_IMAGE}${this.getStore.images.REWARD[0].url}`

      return null
    },

    openLoginDialog() {
      this.showSnack({
        text: this.$vuetify.t('$vuetify.account.rewards.loginPrompt', [this.couponName]),
        color: 'secondary'
      })

      this.setLoginDialog(true)
    },

    addToCart(activeCoupon) {
      this.SET_ACTIVE_COUPON({
        code: this.coupon.code,
        name: this.couponName,
        description: this.coupon.description,
        imageUrl: this.coupon.imageUrl,
        uuid: this.coupon.uuid,
        purchase: !!this.coupon.charges,
        charges: this.coupon.charges,
        orderItem: null
      })

      this.showSnack({
        text: this.$vuetify.t('$vuetify.common.addedToCart', [this.couponName]),
        color: 'secondary'
      })

      this.fetchShoppingCart()
    },

    checkCouponValididity(activeCoupon) {
      if (!this.allowConfig)
        return false

      if (this.isDisabled) {
        this.showSnack({
          text: this.$vuetify.t('$vuetify.account.rewards.inEligible'),
          color: 'error'
        })
        return false
      }

      if (activeCoupon && activeCoupon.code !== this.coupon.code) {
        this.showSnack({
          text: 'Please remove your active coupon first',
          color: 'error'
        })
        return false
      }

      if (this.getExistingOrder.length) {
        if (!!this.getExistingOrder.find(order => order.coupons && order.coupons.length)) {
          this.showSnack({
            text: 'A previous order already used a coupon',
            color: 'error'
          })
          return false
        }
      }

      return true
    },

    openConfig() {
      const activeCoupon = this.getActiveCoupon[0]
      if (!this.checkCouponValididity(activeCoupon))
        return

      if (this.isPurchasable) {
        if (!this.isLoggedIn) {
          this.openLoginDialog()
        } else {
          window.open(this.buildCouponUrl, '_self')
        }
      }
     this.setCouponItemDialog(JSON.parse(JSON.stringify(activeCoupon || this.coupon)))
    },

    isActive(coupon) {
      const active = get(this.getActiveCoupon, '[0]')

      if (!!active) {
        const couponIdentifier = coupon.uuid || coupon.code
        const activeIdentifier = active.uuid || active.code

        return couponIdentifier == activeIdentifier
      }

      return false
    },

    clearCoupon() {
      if (this.$store.getters['groupOrder/isInGroupOrder']) {
        this.$store.dispatch('groupOrder/removeCoupon')
          .then(() => this.$store.dispatch('groupOrder/fetchGroupState'))
          .catch((e) => console.error('[clearCoupon group]', e))
      } else {
        this.removeCoupon(null)
        this.fetchShoppingCart()
      }
    },

    fetchConfigItems(item) {
      let configItems = []
      const list = get(item, 'itemAttributeList', [])

      list.map(option => {
        option.attrValueList.forEach(opt => {
          configItems.push(opt)
        })
      })

      return configItems.filter(Boolean)
    },

    consolidateItems(childItemList) {
      if (!childItemList || !childItemList.length) return []

      try {
        const consolidated = []
        const itemMap = new Map()

        childItemList.forEach(item => {
          if (!item) return
          const itemCode = item.code || ''
          const displayText = this.findDisplayText(item)
          const rawPrice = 'itemPrice' in item ? item.itemPrice : this.getItemPriceFromCharges(item)
          const price = typeof rawPrice === 'number' ? rawPrice.toFixed(2) : rawPrice
          const attributesKey = this.getAttributesKey(item)
          const key = `${itemCode}_${displayText}_${price}_${attributesKey}`

          if (itemMap.has(key)) {
            const existing = itemMap.get(key)
            const newQty = (existing.qty || 1) + (item.qty || 1)
            itemMap.set(key, { ...existing, qty: newQty })
          } else {
            itemMap.set(key, { ...item, qty: item.qty || 1 })
          }
        })

        itemMap.forEach(item => consolidated.push(item))
        return consolidated
      } catch (e) {
        return childItemList
      }
    },

    getAttributesKey(item) {
      if (!item) return 'no-attrs'

      try {
        let keyParts = []

        const attrs = get(item, 'itemAttributeList', [])
        if (attrs && attrs.length) {
          const attrStrings = attrs.map(attr => {
            if (!attr) return ''
            const values = get(attr, 'attrValueList', [])
            if (!values || !values.length) return `${attr.code || ''}:[]`
            return `${attr.code || ''}:[${values.map(v => `${(v && v.code) || (v && v.value) || ''}:${(v && v.qty) || 1}`).sort().join(',')}]`
          }).filter(Boolean).sort()
          keyParts.push('attrs:' + attrStrings.join('|'))
        }

        const children = get(item, 'childItemList', [])
        if (children && children.length) {
          const childStrings = children.map(child => {
            if (!child) return ''
            const childItems = get(child, 'childItemList', [])
            if (!childItems || !childItems.length) return child.code || ''
            return `${child.code || ''}:[${childItems.map(c => `${(c && c.code) || ''}:${(c && c.qty) || 1}`).sort().join(',')}]`
          }).filter(Boolean).sort()
          keyParts.push('children:' + childStrings.join('|'))
        }

        return keyParts.length ? keyParts.join('__') : 'no-attrs'
      } catch (e) {
        return 'no-attrs'
      }
    },

    getItemPriceFromCharges(item) {
      if (!item || !item.charges || !item.charges.length) return 0
      try {
        return item.charges.reduce((sum, charge) => sum + ((charge && charge.price) || 0), 0)
      } catch (e) {
        return 0
      }
    },

    findDisplayText(item) {
      const translations = get(item, 'nameTranslation.translations', null)

      return matchTranslation(translations) || item.name || item.value || ''
    },

    toggleDetails() {
      this.showAllDetails = !this.showAllDetails
    },

    ...mapActions([ 'fetchShoppingCart', 'setCouponItemDialog', 'removeCoupon', 'showSnack' ]),
    ...mapMutations([ 'SET_ACTIVE_COUPON', 'setLoginDialog' ])
  }
}
</script>

<style scoped>
.coupon-options-detail-card {
  border: 1px solid var(--v-primary-base) !important;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  width: 100%;
}

.detail-header {
  font-size: 16px;
  font-weight: 600;
  color: var(--v-primary-base);
  width: 100%;
}

.coupon-description {
  color: #757575;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 8px;
  word-break: break-word;
}

.coupon-rules-list {
  list-style-type: disc;
  color: #757575;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 0 !important;
}
.offer-expiry {
  font-size: 14px;
  color: #757575;
}

.coupon-rules-list li {
  margin-bottom: 4px;
  word-break: break-word;
  overflow: visible;
  list-style: none;
  position: relative;
  padding-left: 1.425em;
}

.coupon-rules-list li::before {
  content: "•";
  position: absolute;
  color: #757575;
  font-size: 21px;
  left: 6.5px !important;
  top: -4px !important;
}


.more-detail-link {
    color: var(--v-primary-base);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 4px;
}

.error-title {
  color: #D8000C
}

.description-collapsed {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 100%;
  list-style: none;
  position: relative;
  padding-left: 1.425em;
}

.description-collapsed::before {
  content: "•";
  position: absolute;
  color: #757575;
  font-size: 21px;
  left: 6.5px !important;
  top: -4px !important;
}

.description-expanded {
  white-space: normal;
  display: list-item;
}

.description-collapsed-ellipsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 100%;
  list-style: none;
  position: relative;
  padding-left: 1.425em;
}
.description-collapsed-ellipsis::before {
  content: "•";
  position: absolute;
  color: #757575;
  font-size: 21px;
  left: 6.5px !important;
  top: -4px !important;
}

.redeemed-items-section {
  padding-right: 22px;
}

.redeemed-item-entry {
  margin-left: 10px;
  margin-bottom: 5px;
}

.individual-redeemed-item {
  margin-bottom: 8px;
}

.item-name {
  font-size: 0.95rem;
}

.item-price {
  font-weight: bold;
  white-space: nowrap;
}

.item-attribute-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px; 
  font-size: 0.85rem;
  color: #666;
  margin-top: 2px; 
}

.item-attribute-qty {
  font-weight: normal;
  margin-right: 3px;
}

.item-attribute-name {
  font-weight: normal;
  flex-grow: 1;
}

.item-attribute-price-value {
  font-weight: normal;
  text-align: end;
  white-space: nowrap;
}

/* History mode styles */
.history-coupon {
  width: 100% !important;
  max-width: none !important;
}

.history-title {
  font-size: 16px !important;
}

.history-rules {
  font-size: 14px !important;
}
</style>